import type { ReactElement } from 'react';
import { Button } from '../primitives/index.js';

export interface PaginationProps {
  /** An opaque cursor is present only when the caller is past the first page. */
  hasPrevious: boolean;
  hasNext: boolean;
  onPrevious: () => void;
  onNext: () => void;
  busy?: boolean;
}

/**
 * Cursor pagination, and only cursor pagination.
 *
 * §9.1 issues an opaque cursor bound to the sort and a hash of the filters. It
 * orders results; it cannot address a page by number and there is no total
 * count. So there are deliberately no page numbers and no "of N" — both would
 * claim an index the API has not built.
 */
export function Pagination({
  hasPrevious,
  hasNext,
  onPrevious,
  onNext,
  busy,
}: PaginationProps): ReactElement | null {
  if (!hasPrevious && !hasNext) return null;
  return (
    <nav className="pagination" aria-label="Pagination">
      {hasPrevious ? (
        <Button variant="secondary" onClick={onPrevious} disabled={busy === true}>
          Back
        </Button>
      ) : null}
      {hasNext ? (
        <Button variant="secondary" onClick={onNext} disabled={busy === true}>
          Next page
        </Button>
      ) : null}
    </nav>
  );
}
